<template>
  <div id="wrapper">
    <!-- <h1>レポート機能：アクティビティレポート</h1> -->
    <div id="manage-wrapper" v-if="isMatchPath">
      <!-- ViewTitleBox -->
      <div class="ibox-tools view-title">
        <h1 class="info-menu view-name">
          <img src="static/img/assets/nav_manage_on_2.png" alt="">
          {{$t('activityReportStr')}}
        </h1>
        <span class="info-right">
        </span>
      </div>
      <!-- /ViewTitleBox -->
      <manage-wrapper-component require-manager>
        <!-- MainView -->
        <article class="wrapper wrapper-content main-column w-100">
          <section class="h-100 animated fadeInUp">
            <div class="input-group date mb-4">
              <label class="control-label">{{$t('periodStr')}}：</label>
              <span class="input-group-addon text-right"><i class="fa fa-calendar" @click="openPickerS"></i></span>
              <datepicker
                :language="datepickerLocale[checkLanguage]"
                :format='format'
                :typeable='true'
                placeholder="Select Date"
                v-model="dateS"
                ref="programaticOpenS"></datepicker>
              <span>〜</span>
              <span class="input-group-addon text-right"><i class="fa fa-calendar" @click="openPickerE"></i></span>
              <datepicker
                :language="datepickerLocale[checkLanguage]"
                :format='format'
                :typeable='true'
                placeholder="Select Date"
                v-model="dateE"
                ref="programaticOpenE"></datepicker>
                  <select v-model="groupSelected" class="input-group-select">
                    <option disabled value="">{{$t('inputGroupNameStr')}}</option>
                    <option v-for="(group, groupId) in getGroupsInfo" v-bind:key="groupId" v-bind:value="groupId">
                      {{ group.groupName}}
                    </option>
                  </select>
                  <div class = "buttons">
                    <b-btn  v-if="!this.refine" @click="trueRefine" variant="primary" class="mb-4 btn-height-size">{{ $t('selectBindStr') }}</b-btn>
                    <b-btn  v-if="this.refine" @click="falseRefine" variant="danger" class="mb-4 btn-height-size">{{ $t('cancelStr') }}</b-btn>
                    <b-btn @click="pushCSV()" variant="primary" class="mb-4 btn-height-size" >{{$t('csvDownloadStr')}}</b-btn>
                  </div>
            </div>
            <!-- <b-tabs class="h-50"> -->
            <b-tabs class="active-wrap h-70">
              <template v-for="t in tabs">
                <b-tab :title="t.label" @click="chgTab(t.key)" :key="t.key">
                  <b-col cols="12" class="view-range-button-col">
                    <b-row>
                      <b-col align-self="end">
                        <template v-for="t in ranges">
                          <button :key="t.key"
                            type="button"
                            class="btn px-4"
                            style="display: inline"
                            :class="{'btn-primary' : viewRange === t.key}"
                            @click="chgRange(t.key)">{{ t.label }}</button>
                        </template>
                      </b-col>
                    </b-row>
                  </b-col>
                  <!-- <b-col cols="12" class="h-50"> -->
                  <b-col cols="12" class="v-chart">
                    <vue-chart
                      type="bar"
                      :data="reports.chartData[t.key]"
                      :options="vueChartOptions"
                      :update-config="{duration: 800, easing: 'easeOutBounce'}"
                      style="width:100%;"
                      class="chart"
                    ></vue-chart>
                  </b-col>
                </b-tab>
              </template>
            </b-tabs>
            <b-card cols="10" class="totals">
              <h4 slot="header">{{ reports.dateS | preparedDate }} ～ {{ reports.dateE | preparedDate}}</h4>
              <b-row>
                <b-col>
                  <b-list-group flush>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      {{$t('activeUserNumStr')}}
                      <span class="num">{{ reports.totals.actives }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      {{$t('activeUserNumStr')}} ({{$t('uniqueUserStr')}})
                      <span class="num">{{ reports.unique.total }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      {{$t('usersNumStr')}}
                      <span class="num">{{ countAvailableUsers }}</span>
                    </b-list-group-item>
                    <b-list-group-item v-if="!isLiteMode" class="d-flex justify-content-between align-items-center">
                      {{$t('OKRRegistNumStr')}}
                      <span class="num">{{ reports.totals['objectives'] + reports.totals['keyresults'] }}</span>
                    </b-list-group-item>
                    <b-list-group-item  v-if="!isLiteMode" class="d-flex justify-content-between align-items-center pl-4 small">
                      <span class="pl-4">{{$t('ObjectiveRegistNumStr')}}</span>
                      <span class="num">{{ reports.totals['objectives'] }}</span>
                    </b-list-group-item>
                    <b-list-group-item  v-if="!isLiteMode" class="d-flex justify-content-between align-items-center pl-4 small">
                      <span class="pl-4">{{$t('KeyResultRegistNumStr')}}</span>
                      <span class="num">{{ reports.totals['keyresults'] }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      {{$t('1on1RegistNumStr')}}
                      <span class="num">{{ reports.totals['1on1s'] }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      {{$t('FBRequestRegistNumStr')}}
                      <span class="num">{{ reports.totals['rtfbs'] }}</span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
                <b-col>
                  <b-list-group flush>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      {{$t('commentNumStr')}}
                      <span class="num">{{ reports.totals['comment']['total'] }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      {{$t('commentNumOfPeopleStr')}}
                      <span class="num">{{ reports.poster.total }}</span>
                    </b-list-group-item>
                    <b-list-group-item  v-if="!isLiteMode" class="d-flex justify-content-between align-items-center">
                      {{$t('OKRCommentNumStr')}}
                      <span class="num">{{ reports.totals['comment']['objectives'] + reports.totals['comment']['keyresults'] }}</span>
                    </b-list-group-item>
                    <b-list-group-item  v-if="!isLiteMode" class="d-flex justify-content-between align-items-center pl-4 small">
                      <span class="pl-4">{{$t('ObjectiveCommentNumStr')}}</span>
                      <span class="num">{{ reports.totals['comment']['objectives'] }}</span>
                    </b-list-group-item>
                    <b-list-group-item  v-if="!isLiteMode" class="d-flex justify-content-between align-items-center pl-4 small">
                      <span class="pl-4">{{$t('KeyResultCommentNumStr')}}</span>
                      <span class="num">{{ reports.totals['comment']['keyresults'] }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      {{$t('1on1CommentNumStr')}}
                      <span class="num">{{ reports.totals['comment']['1on1s'] }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      {{$t('FBRequestCommentNumStr')}}
                      <span class="num">{{ reports.totals['comment']['rtfbs'] }}</span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
                <b-col>
                  <b-list-group flush>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      {{$t('likeNumStr')}}
                      <span class="num">{{ reports.totals['like']['total'] }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex justify-content-between align-items-center pl-4 small">
                      <span class="pl-4">{{$t('FBRequestLikeNumStr')}}</span>
                      <span class="num">{{ reports.totals['like']['rtfbs'] }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex justify-content-between align-items-center pl-4 small">
                      <span class="pl-4">{{$t('CommentLikeNumStr')}}</span>
                      <span class="num">{{ reports.totals['like']['comments'] }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      {{$t('likeNumOfPeopleStr')}}
                      <span class="num">{{ reports.liker.total }}</span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </b-card>
          </section>
        </article>
      </manage-wrapper-component>
    </div>
    <div>
      <transition name="fade">
        <div v-if="showModal" class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-header">
                <slot name="header">
                  <div class="ibox-tools view-title ">
                  </div>
                </slot>
                <h1 class="text-right">
                  <b-btn variant="primary" @click="modalAllCheck" class="btn-height-size" >{{$t('allCheckStr')}}</b-btn>
                  <b-btn variant="primary" @click="modalAllUnCheck" class="btn-height-size">{{$t('allUnCheckStr')}}</b-btn>
                </h1>
              </div>
              <b-tabs class="active-wrap h-70 container-fluid">
                <b-tab class="col" :title="$t('organizationLabelStr')" @click="modalPeopleChange('organization')">
                </b-tab>
                <b-tab class="col" :title="$t('peopleGroupTitleType')" @click="modalPeopleChange('group')">
                </b-tab>
              </b-tabs>
              <div class="modal-body">
                <div class="m-body-wrap">
                  <slot name="body">
                    <div v-if="this.modalPeopleSelect === 'group'" class="ibox">
                      <div class="ibox-content">
                        <div class="ibox-content search-resultview">
                          <ul >
                            <li v-for="(group, groupId) in getOnlyGroupsInfo" @click="onClickModalGroup(groupId)" :key="groupId"  class="flex-box fl-between group-item cursor">
                              <span class="group-name">{{ group.groupName }}
                                <span v-if="modalCheckGroups.includes(groupId)" >
                                  <span class="check-mark"></span>
                                </span>
                              </span>
                              <span class="group-info">{{$t('memberStr')}}:
                                <span class="menber-count">({{ Object.keys(group.members||{}).length }})</span>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <organization-item  :editAble="false" :bindSelectedByParent="true" :noneSelect="false" :parentSelect="true" @onClickOrganization="onClickOrganization" :checkedOrganizations="modalCheckGroups" :bans="checkBans"/>
                    </div>
                  </slot>
                </div>
              </div>
              <div class="modal-footer">
                <slot name="footer">
                  <div class="row okr-regist-btnset">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-sm-offset-2"><button @click="onClickModalOk" type="button" class="modal-default-button btn btn-success">{{ $t('modalOkStr') }}</button></div>
                    <div class="col-lg-4 col-md-4 col-sm-4"><button @click="closeModal" type="button" class="modal-default-button btn btn-danger">{{ $t('cancelStr') }}</button></div>
                  </div>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import VueChart from 'vuechart'
import { mapGetters } from 'vuex'
import {i18n, liteMode} from '@/main.js'
import {ja, en, zh} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import ManageWrapperComponent from '@/components/Manage/ManageWrapperComponent'
import OrganizationItem from '@/components/People/OrganizationItem'
const moment = extendMoment(Moment)

export default {
  name: 'ReportActivity',
  components: {
    [VueChart.name]: VueChart,
    Datepicker,
    ManageWrapperComponent,
    OrganizationItem
  },
  data: function () {
    return {
      isLiteMode: liteMode,
      format: 'yyyy/MM/dd',
      datepickerLocale: {
        ja: ja,
        en: en,
        zh_tr: zh
      },
      vueChartOptions: {
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      },
      dateS: moment().subtract(1, 'month').format('YYYY/MM/DD'),
      dateE: moment().format('YYYY/MM/DD'),
      viewRange: 'daily',
      selected: '',
      groupSelected: '',
      groupSelectCSV: '',
      refine: false,
      modalCheckGroups: [],
      showModal: false,
      modalPeopleSelect: 'group',
      modalAllSelect: true,
      checkBans: []
    }
  },
  methods: {
    chgTab (target) {
      console.log('chgTab: ' + target)
    },
    trueRefine  () {
      this.refine = true
    },
    falseRefine () {
      this.refine = false
    },
    dateFomatter (date) {
      if (toString.call(date) === '[object Date]') {
        return moment(date).format('YYYY_MM_DD')
      } else {
        return date
      }
    },
    CSVreports: function (groupId) {
      const keys = [
        'access', 'objectives', 'keyresults', 'rtfbs', '1on1s', '1on1requests', 'comments', 'likes', 'commentLikes'
      ]
      const span = [
        'daily', 'weekly', 'monthly'
      ]
      // const tabs = [
      //   'summary', 'comments', 'likes'
      // ]
      const dateLabels = {
        daily: [],
        weekly: [],
        monthly: []
      }
      let reports = { comment: {}, like: {} }
      for (let k of keys) {
        reports[k] = {}
        reports['comment'][k] = {}
        reports['comment']['total'] = {}
        reports['like'][k] = {}
        reports['like']['total'] = {}
        for (let s of span) {
          reports[k][s] = {}
          reports['comment'][k][s] = {}
          reports['comment']['total'][s] = {}
          reports['like'][k][s] = {}
          reports['like']['total'][s] = {}
          // for (let t of tabs) {
          //   reports[k][s][t] = {}
          // }
        }
      }
      reports.totals = {
        'objectives': 0,
        'keyresults': 0,
        '1on1s': 0,
        '1on1requests': 0,
        'rtfbs': 0,
        'comments': 0,
        'comment': {
          'objectives': 0,
          'keyresults': 0,
          '1on1s': 0,
          'rtfbs': 0,
          'other': 0,
          'total': 0
        },
        'likes': 0,
        'like': {
          'rtfbs': 0,
          'comments': 0,
          'total': 0,
          'other': 0
        },
        'other': 0
      }
      reports.unique = {
        daily: {},
        weekly: {},
        monthly: {},
        total: {}
      }
      reports.poster = {
        daily: {},
        weekly: {},
        monthly: {},
        total: {}
      }
      reports.liker = {
        daily: {},
        weekly: {},
        monthly: {},
        total: {}
      }
      if (liteMode) {
        // liteMode処理
        keys.splice(keys.indexOf('objectives'), 2)
        delete reports.totals.comment.objectives
        delete reports.totals.comment.keyresults
      }
      let dateS = this.dateS
      let dateE = this.dateE
      reports.dateS = dateS
      reports.dateE = dateE
      const metaSummary = this.getMetaSummary
      console.log('めたサマリ', dateS, dateE, metaSummary)

      console.log('range:', moment.range(dateS, dateE).by('days'))
      for (let day of moment.range(dateS, dateE).by('days')) {
        // console.log('day:' + day.format('YYYY-MM-DD'))
        // let ymd = day.format('YYYY/MM/DD')
        // let ym = day.format('YYYY-MM')
        console.log('day:' + day.format('YYYY/MM/DD'))
        let ymd = day.format('YYYY/MM/DD')
        let ym = day.format('YYYY/MM')
        let y = day.format('YYYY')
        let m = day.format('MM')
        let d = day.format('DD')
        let w = day.weekday(0).format('YYYY/MM/DD') + '～'
        // let w = day.format('W')
        // console.log(y + '-' + m + '-' + d)
        dateLabels.daily.push(ymd)
        dateLabels.weekly.push(w)
        dateLabels.monthly.push(ym)
        // console.log(y + '-' + m + '-' + d + ' : ' + w)
        for (let k of keys) {
          if (k !== 'access') {
            if (!reports[k].daily[ymd]) { reports[k].daily[ymd] = 0 }
            if (!reports[k].weekly[w]) { reports[k].weekly[w] = 0 }
            if (!reports[k].monthly[ym]) { reports[k].monthly[ym] = 0 }
            if (!reports['comment'][k].daily[ymd]) { reports['comment'][k].daily[ymd] = 0 }
            if (!reports['comment'][k].weekly[w]) { reports['comment'][k].weekly[w] = 0 }
            if (!reports['comment'][k].monthly[ym]) { reports['comment'][k].monthly[ym] = 0 }
            if (!reports['like'][k].daily[ymd]) { reports['like'][k].daily[ymd] = 0 }
            if (!reports['like'][k].weekly[w]) { reports['like'][k].weekly[w] = 0 }
            if (!reports['like'][k].monthly[ym]) { reports['like'][k].monthly[ym] = 0 }
          }
          if (!reports['comment']['total'].daily[ymd]) { reports['comment']['total'].daily[ymd] = 0 }
          if (!reports['comment']['total'].weekly[w]) { reports['comment']['total'].weekly[w] = 0 }
          if (!reports['comment']['total'].monthly[ym]) { reports['comment']['total'].monthly[ym] = 0 }
          if (!reports['like']['total'].daily[ymd]) { reports['like']['total'].daily[ymd] = 0 }
          if (!reports['like']['total'].weekly[w]) { reports['like']['total'].weekly[w] = 0 }
          if (!reports['like']['total'].monthly[ym]) { reports['like']['total'].monthly[ym] = 0 }
          if (!reports['unique'].daily[ymd]) { reports['unique'].daily[ymd] = {} }
          if (!reports['unique'].weekly[w]) { reports['unique'].weekly[w] = {} }
          if (!reports['unique'].monthly[ym]) { reports['unique'].monthly[ym] = {} }
          if (!reports['poster'].daily[ymd]) { reports['poster'].daily[ymd] = {} }
          if (!reports['poster'].weekly[w]) { reports['poster'].weekly[w] = {} }
          if (!reports['poster'].monthly[ym]) { reports['poster'].monthly[ym] = {} }
          if (!reports['liker'].daily[ymd]) { reports['liker'].daily[ymd] = {} }
          if (!reports['liker'].weekly[w]) { reports['liker'].weekly[w] = {} }
          if (!reports['liker'].monthly[ym]) { reports['liker'].monthly[ym] = {} }
          if (!!metaSummary[y] && !!metaSummary[y][m] && !!metaSummary[y][m][d] && !!metaSummary[y][m][d][k]) {
            // console.log('metaSummary: ' + k + ymd, Object.keys(metaSummary[y][m][d][k]))
            for (let u of Object.keys(metaSummary[y][m][d][k])) {
              if (k === 'comments') {
                // console.log('* Comment Check!')
                for (let kt of Object.values(metaSummary[y][m][d][k][u])) {
                  let ktname = '' + kt
                  // console.log(u, kt)
                  ktname = ktname.split('_')[0]
                  if (!reports.totals.comment.hasOwnProperty(kt)) { ktname = 'other' }
                  // console.log(u, kt)
                  if (!reports['comment'][ktname]) {
                    reports['comment'][ktname] = {
                      daily: {},
                      weekly: {},
                      monthly: {}
                    }
                  }
                  if (kt.hasOwnProperty(groupId)) {
                    reports['comment'][ktname].daily[ymd]++
                    reports['comment'][ktname].weekly[w]++
                    reports['comment'][ktname].monthly[ym]++
                    reports['comment']['total'].daily[ymd]++
                    reports['comment']['total'].weekly[w]++
                    reports['comment']['total'].monthly[ym]++
                    reports.totals['comment'][ktname]++
                    reports.totals['comment']['total']++
                    reports.unique.daily[ymd][u] = true
                    reports.unique.weekly[w][u] = true
                    reports.unique.monthly[ym][u] = true
                    reports.unique.total[u] = true
                    reports.poster.daily[ymd][u] = true
                    reports.poster.weekly[w][u] = true
                    reports.poster.monthly[ym][u] = true
                    reports.poster.total[u] = true
                  }
                }
              } else if (k === 'access') {
                // ToDo: 表示画面集計？
              } else if (k === 'likes' || k === 'commentLikes') {
                reports.liker.daily[ymd][u] = true
                reports.liker.weekly[w][u] = true
                reports.liker.monthly[ym][u] = true
                reports.liker.total[u] = true
                // console.log('* Comment Check!')
                for (let kc of Object.keys(metaSummary[y][m][d][k][u])) {
                  let kt = k === 'likes' ? 'rtfbs' : 'comments'
                  if (!reports.totals.like.hasOwnProperty(kt)) { kt = 'other' }
                  console.log(u, kc)
                  if (!reports['like'][kt]) {
                    reports['like'][kt] = {
                      daily: {},
                      weekly: {},
                      monthly: {}
                    }
                  }
                  if (kt.hasOwnProperty(groupId)) {
                    reports['like'][kt].daily[ymd]++
                    reports['like'][kt].weekly[w]++
                    reports['like'][kt].monthly[ym]++
                    reports['like']['total'].daily[ymd]++
                    reports['like']['total'].weekly[w]++
                    reports['like']['total'].monthly[ym]++
                    reports.totals['like'][kt]++
                    reports.totals['like']['total']++
                    reports.unique.daily[ymd][u] = true
                    reports.unique.weekly[w][u] = true
                    reports.unique.monthly[ym][u] = true
                    reports.unique.total[u] = true
                  }
                }
              } else {
                // console.log('* Comment Check!')
                for (let kt of Object.values(metaSummary[y][m][d][k][u])) {
                  let ktname = '' + kt
                  // console.log(u, kt)
                  ktname = ktname.split('_')[0]
                  if (!reports.totals.comment.hasOwnProperty(kt)) { ktname = 'other' }
                  if (kt.hasOwnProperty(groupId)) {
                    reports[k].daily[ymd]++
                    reports[k].weekly[w]++
                    reports[k].monthly[ym]++
                    reports.totals[k]++
                    reports.unique.daily[ymd][u] = true
                    reports.unique.weekly[w][u] = true
                    reports.unique.monthly[ym][u] = true
                    reports.unique.total[u] = true
                    // console.log(reports['comment'][ktname], reports['comment']['total'])
                  }
                }
              }
            }
          } else {
            // console.log('No Data for: ' + k + ' ' + ymd)
          }
        }
      }
      for (let t of Object.keys(reports.unique)) {
        console.log('reportユニーク', reports.unique)
        if (t !== 'total') {
          for (let d of Object.keys(reports.unique[t])) {
            reports.unique[t][d] = Object.keys(reports.unique[t][d]).length
          }
        } else {
          reports.unique[t] = Object.keys(reports.unique[t]).length
        }
      }
      for (let t of Object.keys(reports.poster)) {
        if (t !== 'total') {
          for (let d of Object.keys(reports.poster[t])) {
            reports.poster[t][d] = Object.keys(reports.poster[t][d]).length
          }
        } else {
          reports.poster[t] = Object.keys(reports.poster[t]).length
        }
      }
      for (let t of Object.keys(reports.liker)) {
        if (t !== 'total') {
          for (let d of Object.keys(reports.liker[t])) {
            reports.liker[t][d] = Object.keys(reports.liker[t][d]).length
          }
        } else {
          reports.liker[t] = Object.keys(reports.liker[t]).length
        }
      }
      console.log(dateLabels.weekly, dateLabels.monthly)
      dateLabels.weekly = [...new Set(dateLabels.weekly)]
      dateLabels.monthly = [...new Set(dateLabels.monthly)]
      console.log(dateLabels.weekly, dateLabels.monthly)
      // console.log('this?', this.chartData, this.viewRange)
      console.log('Actives', Object.values(reports.unique[this.viewRange]))
      console.log('Actives:Total', Object.values(reports.unique[this.viewRange]).reduce((a, b) => { return a + b }))
      reports.totals.actives = Object.values(reports.unique[this.viewRange]).reduce((a, b) => { return a + b })
      reports.chartData = {
        summary: {
          datasets: [{
            label: this.$t('activesStr'),
            data: Object.values(reports.unique[this.viewRange]),
            borderColor: '#ff6600',
            backgroundColor: 'transparent',
            fill: false,
            type: 'line'
          }, {
            label: this.$t('okrDetailType'),
            data: Object.values(reports['objectives'][this.viewRange]),
            backgroundColor: '#333399',
            type: 'bar'
          }, {
            label: this.$t('keyResultDetailType'),
            data: Object.values(reports['keyresults'][this.viewRange]),
            backgroundColor: '#6666ff',
            type: 'bar'
          }, {
            label: this.$t('oneOnTitleType'),
            data: Object.values(reports['1on1s'][this.viewRange]),
            backgroundColor: '#00cc99',
            type: 'bar'
          }, {
            label: this.$t('rtfbType'),
            data: Object.values(reports['rtfbs'][this.viewRange]),
            backgroundColor: '#cc6600',
            type: 'bar'
          }],
          labels: dateLabels[this.viewRange]
        },
        comments: {
          datasets: [{
            label: this.$t('commentLabelTitle'),
            data: Object.values(reports['comment']['total'][this.viewRange]),
            borderColor: '#cccc00',
            backgroundColor: 'transparent',
            fill: false,
            type: 'line'
          }, {
            label: this.$t('okrDetailType'),
            data: Object.values(reports['comment']['objectives'][this.viewRange]),
            backgroundColor: '#333399',
            type: 'bar'
          }, {
            label: this.$t('keyResultDetailType'),
            data: Object.values(reports['comment']['keyresults'][this.viewRange]),
            backgroundColor: '#6666ff',
            type: 'bar'
          }, {
            label: this.$t('oneOnTitleType'),
            data: Object.values(reports['comment']['1on1s'][this.viewRange]),
            backgroundColor: '#00cc99',
            type: 'bar'
          }, {
            label: this.$t('rtfbType'),
            data: Object.values(reports['comment']['rtfbs'][this.viewRange]),
            backgroundColor: '#cc6600',
            type: 'bar'
          }],
          labels: dateLabels[this.viewRange]
        },
        likes: {
          datasets: [{
            label: this.$t('niceBtnTitle'),
            data: Object.values(reports['like']['total'][this.viewRange]),
            borderColor: '#ffcc00',
            backgroundColor: 'transparent',
            fill: false,
            type: 'line'
          }, {
            label: this.$t('rtfbType'),
            data: Object.values(reports['like']['rtfbs'][this.viewRange]),
            backgroundColor: '#cc6600',
            type: 'bar'
          }, {
            label: this.$t('commantLabelTitle'),
            data: Object.values(reports['like']['comments'][this.viewRange]),
            backgroundColor: '#cccc00',
            type: 'bar'
          }],
          labels: dateLabels[this.viewRange]
        }
      }
      if (liteMode) {
        // liteMode処理
        reports.chartData.summary.datasets.splice(1, 2)
        reports.chartData.comments.datasets.splice(1, 2)
      }
      console.log('this.chartData', reports.chartData)
      console.log('reports', reports)
      return reports
    },
    lookUpOrganization: function (organizationId) {
      // childgroupsが存在するorganizationの中身を渡す
      console.log('org', this.getOrganizationExpansion([organizationId]))
    },
    onClickOrganization: function (organizationId) {
      const exOrg = this.getOrganizationExpansion([organizationId])
      if (this.modalCheckGroups.includes(organizationId)) {
        for (let org of exOrg) {
          const checkOrganizationIndex = this.modalCheckGroups.indexOf(org)
          if (checkOrganizationIndex >= 0) {
            this.modalCheckGroups.splice(checkOrganizationIndex, 1)
          }
          const banIndex = this.checkBans.indexOf(org)
          if (banIndex >= 0 && org !== exOrg[0]) {
            this.checkBans.splice(banIndex, 1)
          }
        }
      } else {
        for (let org of exOrg) {
          const checkOrganizationIndex = this.modalCheckGroups.indexOf(org)
          if (checkOrganizationIndex < 0) {
            this.modalCheckGroups.push(org)
          }
          const banIndex = this.checkBans.indexOf(org)
          if (banIndex < 0 && org !== exOrg[0]) {
            this.checkBans.push(org)
          }
        }
      }
    },
    modalPeopleChange: function (label) {
      this.modalPeopleSelect = label
    },
    modalAllCheck: function () {
      for (let k of Object.keys(this.getGroups)) {
        if ((this.modalPeopleSelect === 'organization') ? !!this.getGroups[k].isOrganization : !this.getGroups[k].isOrganization) {
          if (!this.modalCheckGroups.includes(k)) {
            this.modalCheckGroups.push(k)
          }
        }
      }
      for (let group of Object.keys(this.getOpenOrganization(this.modalCheckGroups))) {
        if (this.getOpenOrganization(this.modalCheckGroups)[group].depth > 0) {
          const exOrg = this.getOrganizationExpansion(group)
          for (let org of exOrg) {
            const banIndex = this.checkBans.indexOf(org)
            if (banIndex < 0 && org !== exOrg[0]) {
              this.checkBans.push(org)
            }
          }
        }
      }
    },
    modalAllUnCheck: function () {
      for (let k of Object.keys(this.getGroups)) {
        if ((this.modalPeopleSelect === 'organization') ? !!this.getGroups[k].isOrganization : !this.getGroups[k].isOrganization) {
          if (this.modalCheckGroups.includes(k)) {
            this.modalCheckGroups.splice(this.modalCheckGroups.indexOf(k), 1)
          }
        }
      }
      for (let group of Object.keys(this.getOpenOrganization(this.modalCheckGroups))) {
        if (this.getOpenOrganization(this.modalCheckGroups)[group].depth > 0) {
          const exOrg = this.getOrganizationExpansion(group)
          for (let org of exOrg) {
            const banIndex = this.checkBans.indexOf(org)
            if (banIndex < 0 && org !== exOrg[0]) {
              this.checkBans.push(org)
            }
          }
        }
      }
    },
    closeModal: function () {
      this.modalCheckGroups = []
      this.showModal = false
    },
    onClickModalGroup: function (groupId) {
      let modalCheckIndex = this.modalCheckGroups.indexOf(groupId)
      if (modalCheckIndex < 0) {
        this.modalCheckGroups.push(groupId)
      } else {
        this.modalCheckGroups.splice(modalCheckIndex, 1)
      }
    },
    onClickModalOk: function () {
      let reportJsons = {}
      for (let group of this.modalCheckGroups) {
        reportJsons[group] = this.CSVreports(group)
      }
      const downloadCSVName = [
        'activityreport',
        // this.viewRange,
        this.dateFomatter(this.reports.dateS),
        this.dateFomatter(this.reports.dateE)
      ].join('-')
      this.downloadCSV(this.CreateSummaryCSV(reportJsons), downloadCSVName)
      this.modalCheckGroups = []
      this.showModal = false
    },
    CreateSummaryCSV: function (reports) {
      let csv = ''
      csv = ['groups']
      csv.push('アクティブユーザ数')
      csv.push('アクティブユーザ数(unique)')
      if (!this.isLiteMode) { csv.push('objective登録数') }
      if (!this.isLiteMode) { csv.push('keyResult登録数') }
      if (!this.isLiteMode) { csv.push('OKR登録数') }
      csv.push('1on1登録数')
      csv.push('FB Requests登録数')
      if (!this.isLiteMode) { csv.push('Objectiveコメント数') }
      if (!this.isLiteMode) { csv.push('Key Resultコメント数') }
      csv.push('1on1コメント数')
      csv.push('FB Requestコメント数')
      csv.push('コメント数')
      csv.push('FB Requestいいね数')
      csv.push('コメントいいね数')
      csv.push('いいね数')
      csv = csv.join(',') + '\r\n'
      for (let group of Object.keys(reports)) {
        let stock = []
        stock.push(this.getGroups[group].groupName || '')
        stock.push(reports[group]['totals']['actives'] || 0)
        stock.push(reports[group]['unique']['total'] || 0)
        if (!this.isLiteMode) { stock.push(reports[group]['totals']['objectives'] || 0) }
        if (!this.isLiteMode) { stock.push(reports[group]['totals']['keyresults'] || 0) }
        if (!this.isLiteMode) { stock.push((reports[group]['totals']['objectives'] || 0) + (reports[group]['totals']['keyresults'] || 0)) }
        stock.push(reports[group]['totals']['1on1s'] || 0)
        stock.push(reports[group]['totals']['rtfbs'] || 0)
        if (!this.isLiteMode) { stock.push(reports[group]['totals']['comment']['objectives'] || 0) }
        if (!this.isLiteMode) { stock.push(reports[group]['totals']['comment']['keyresults'] || 0) }
        stock.push(reports[group]['totals']['comment']['1on1s'] || 0)
        stock.push(reports[group]['totals']['comment']['rtfbs'] || 0)
        stock.push(reports[group]['totals']['comment']['total'] || 0)
        stock.push(reports[group]['totals']['like']['rtfbs'] || 0)
        stock.push(reports[group]['totals']['like']['comments'] || 0)
        stock.push((reports[group]['totals']['like']['rtfbs'] || 0) + (reports[group]['totals']['like']['comments'] || 0))
        csv = csv + stock.join(',') + '\r\n'
      }
      return csv
    },
    pushCSV: function () {
      this.showModal = true
    },
    chgRange (target) {
      console.log('chgRange: ' + target)
      this.viewRange = target
    },
    openPickerS: function () {
      this.$refs.programaticOpenS.showCalendar()
    },
    openPickerE: function () {
      this.$refs.programaticOpenE.showCalendar()
    }
  },
  filters: {
    preparedDate: function (date) {
      return moment(date).format('YYYY/MM/DD')
    }
  },
  mounted () {
    console.info('ReportActivity: mounted.')
    this.$store.dispatch('_meta/GET_META_SUMMARY')
  },
  destroyed () {
    console.info('ReportActivity: destroyed.')
    this.$store.dispatch('_meta/UNBIND_META_SUMMARY')
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'ReportActivity'
    },
    checkLanguage () {
      return i18n.locale
    },
    tabs () {
      return [
        {
          key: 'summary',
          label: this.$t('labelSummary')
        },
        {
          key: 'comments',
          label: this.$t('commentLabelTitle')
        },
        {
          key: 'likes',
          label: this.$t('niceBtnTitle')
        }
      ]
    },
    ranges () {
      return [
        {
          key: 'daily',
          label: this.$t('dayStr')
        },
        {
          key: 'weekly',
          label: this.$t('weekStr')
        },
        {
          key: 'monthly',
          label: this.$t('monthStr')
        }
      ]
    },
    ...mapGetters('repository/', [
      'getIsAllowedIPAddressForManagement'
    ]),
    ...mapGetters('groups/', [
      'getGroupsByIds',
      'getGroups',
      'getOnlyGroupsByIds'
    ]),
    ...mapGetters('_meta/', [
      'getMetaSummary',
      'getMetaUsersList',
      'getMetaIsManager'
    ]),
    ...mapGetters('peoples/', [
      'downloadCSV'
    ]),
    ...mapGetters('organizations/', [
      'getOrganizationExpansion',
      'getOpenOrganization'
    ]),
    isManager: function () {
      return this.getMetaIsManager
    },
    getGroupsInfo: function () {
      console.log('ここthis.getGroups::', this.getGroups)
      let groups = this.getGroupsByIds(Object.keys(this.getGroups))
      delete groups['.key']
      // return this.getGroupsByIds(Object.keys(this.getGroups))
      return groups
    },
    getOnlyGroupsInfo: function () {
      let groups = this.getOnlyGroupsByIds(Object.keys(this.getGroups))
      delete groups['.key']
      // return this.getGroupsByIds(Object.keys(this.getGroups))
      return groups
    },
    countAvailableUsers1 () {
      const countAvailableUsers = this.$firebase.functions().httpsCallable('countAvailableUsers')
      return countAvailableUsers().then(val => {
        console.log('countAvailableUsers:', val)
        if (val.data && val.data.status && val.data.status === 'ok') {
          return val.data.count || 0
        }
        return 0
      }).catch(err => {
        console.log('countAvailableUsers:', err)
        return 0
      })
    },
    countAvailableUsers () {
      const metauserslist = this.getMetaUsersList
      // console.log('countAvailableUsers:', metauserslist)
      let count = 0
      Object.keys(metauserslist || {}).forEach(x => {
        let u = metauserslist[x]
        count += (1 * (!u.unavailable && !u.disabled && !u.isDeveloper && !u.isDeleted))
        // console.log('countAvailableUsers:', count)
      })
      return count
    },
    reports () {
      const keys = [
        'access', 'objectives', 'keyresults', 'rtfbs', '1on1s', '1on1requests', 'comments', 'likes', 'commentLikes'
      ]
      const span = [
        'daily', 'weekly', 'monthly'
      ]
      // const tabs = [
      //   'summary', 'comments', 'likes'
      // ]
      const dateLabels = {
        daily: [],
        weekly: [],
        monthly: []
      }
      let reports = { comment: {}, like: {} }
      for (let k of keys) {
        reports[k] = {}
        reports['comment'][k] = {}
        reports['comment']['total'] = {}
        reports['like'][k] = {}
        reports['like']['total'] = {}
        for (let s of span) {
          reports[k][s] = {}
          reports['comment'][k][s] = {}
          reports['comment']['total'][s] = {}
          reports['like'][k][s] = {}
          reports['like']['total'][s] = {}
          // for (let t of tabs) {
          //   reports[k][s][t] = {}
          // }
        }
      }
      reports.totals = {
        'objectives': 0,
        'keyresults': 0,
        '1on1s': 0,
        '1on1requests': 0,
        'rtfbs': 0,
        'comments': 0,
        'comment': {
          'objectives': 0,
          'keyresults': 0,
          '1on1s': 0,
          'rtfbs': 0,
          'other': 0,
          'total': 0
        },
        'likes': 0,
        'like': {
          'rtfbs': 0,
          'comments': 0,
          'total': 0,
          'other': 0
        },
        'other': 0
      }
      reports.unique = {
        daily: {},
        weekly: {},
        monthly: {},
        total: {}
      }
      reports.poster = {
        daily: {},
        weekly: {},
        monthly: {},
        total: {}
      }
      reports.liker = {
        daily: {},
        weekly: {},
        monthly: {},
        total: {}
      }
      if (liteMode) {
        // liteMode処理
        keys.splice(keys.indexOf('objectives'), 2)
        delete reports.totals.comment.objectives
        delete reports.totals.comment.keyresults
      }
      let dateS = this.dateS
      let dateE = this.dateE
      reports.dateS = dateS
      reports.dateE = dateE
      const metaSummary = this.getMetaSummary
      console.log('めたサマリ', dateS, dateE, metaSummary)

      console.log('range:', moment.range(dateS, dateE).by('days'))
      for (let day of moment.range(dateS, dateE).by('days')) {
        // console.log('day:' + day.format('YYYY-MM-DD'))
        // let ymd = day.format('YYYY/MM/DD')
        // let ym = day.format('YYYY-MM')
        console.log('day:' + day.format('YYYY/MM/DD'))
        let ymd = day.format('YYYY/MM/DD')
        let ym = day.format('YYYY/MM')
        let y = day.format('YYYY')
        let m = day.format('MM')
        let d = day.format('DD')
        let w = day.weekday(0).format('YYYY/MM/DD') + '～'
        // let w = day.format('W')
        // console.log(y + '-' + m + '-' + d)
        dateLabels.daily.push(ymd)
        dateLabels.weekly.push(w)
        dateLabels.monthly.push(ym)
        // console.log(y + '-' + m + '-' + d + ' : ' + w)
        for (let k of keys) {
          if (k !== 'access') {
            if (!reports[k].daily[ymd]) { reports[k].daily[ymd] = 0 }
            if (!reports[k].weekly[w]) { reports[k].weekly[w] = 0 }
            if (!reports[k].monthly[ym]) { reports[k].monthly[ym] = 0 }
            if (!reports['comment'][k].daily[ymd]) { reports['comment'][k].daily[ymd] = 0 }
            if (!reports['comment'][k].weekly[w]) { reports['comment'][k].weekly[w] = 0 }
            if (!reports['comment'][k].monthly[ym]) { reports['comment'][k].monthly[ym] = 0 }
            if (!reports['like'][k].daily[ymd]) { reports['like'][k].daily[ymd] = 0 }
            if (!reports['like'][k].weekly[w]) { reports['like'][k].weekly[w] = 0 }
            if (!reports['like'][k].monthly[ym]) { reports['like'][k].monthly[ym] = 0 }
          }
          if (!reports['comment']['total'].daily[ymd]) { reports['comment']['total'].daily[ymd] = 0 }
          if (!reports['comment']['total'].weekly[w]) { reports['comment']['total'].weekly[w] = 0 }
          if (!reports['comment']['total'].monthly[ym]) { reports['comment']['total'].monthly[ym] = 0 }
          if (!reports['like']['total'].daily[ymd]) { reports['like']['total'].daily[ymd] = 0 }
          if (!reports['like']['total'].weekly[w]) { reports['like']['total'].weekly[w] = 0 }
          if (!reports['like']['total'].monthly[ym]) { reports['like']['total'].monthly[ym] = 0 }
          if (!reports['unique'].daily[ymd]) { reports['unique'].daily[ymd] = {} }
          if (!reports['unique'].weekly[w]) { reports['unique'].weekly[w] = {} }
          if (!reports['unique'].monthly[ym]) { reports['unique'].monthly[ym] = {} }
          if (!reports['poster'].daily[ymd]) { reports['poster'].daily[ymd] = {} }
          if (!reports['poster'].weekly[w]) { reports['poster'].weekly[w] = {} }
          if (!reports['poster'].monthly[ym]) { reports['poster'].monthly[ym] = {} }
          if (!reports['liker'].daily[ymd]) { reports['liker'].daily[ymd] = {} }
          if (!reports['liker'].weekly[w]) { reports['liker'].weekly[w] = {} }
          if (!reports['liker'].monthly[ym]) { reports['liker'].monthly[ym] = {} }
          if (!!metaSummary[y] && !!metaSummary[y][m] && !!metaSummary[y][m][d] && !!metaSummary[y][m][d][k]) {
            // console.log('metaSummary: ' + k + ymd, Object.keys(metaSummary[y][m][d][k]))
            for (let u of Object.keys(metaSummary[y][m][d][k])) {
              if (k === 'comments') {
                // console.log('* Comment Check!')
                for (let kt of Object.values(metaSummary[y][m][d][k][u])) {
                  let ktname = '' + kt
                  // console.log(u, kt)
                  ktname = ktname.split('_')[0]
                  if (!reports.totals.comment.hasOwnProperty(kt)) { ktname = 'other' }
                  // console.log(u, kt)
                  if (!reports['comment'][ktname]) {
                    reports['comment'][ktname] = {
                      daily: {},
                      weekly: {},
                      monthly: {}
                    }
                  }
                  if (!this.refine || kt.hasOwnProperty(this.groupSelected)) {
                    reports['comment'][ktname].daily[ymd]++
                    reports['comment'][ktname].weekly[w]++
                    reports['comment'][ktname].monthly[ym]++
                    reports['comment']['total'].daily[ymd]++
                    reports['comment']['total'].weekly[w]++
                    reports['comment']['total'].monthly[ym]++
                    reports.totals['comment'][ktname]++
                    reports.totals['comment']['total']++
                    reports.unique.daily[ymd][u] = true
                    reports.unique.weekly[w][u] = true
                    reports.unique.monthly[ym][u] = true
                    reports.unique.total[u] = true
                    reports.poster.daily[ymd][u] = true
                    reports.poster.weekly[w][u] = true
                    reports.poster.monthly[ym][u] = true
                    reports.poster.total[u] = true
                  }
                }
              } else if (k === 'access') {
                // ToDo: 表示画面集計？
              } else if (k === 'likes' || k === 'commentLikes') {
                reports.liker.daily[ymd][u] = true
                reports.liker.weekly[w][u] = true
                reports.liker.monthly[ym][u] = true
                reports.liker.total[u] = true
                // console.log('* Comment Check!')
                for (let kc of Object.keys(metaSummary[y][m][d][k][u])) {
                  let kt = k === 'likes' ? 'rtfbs' : 'comments'
                  if (!reports.totals.like.hasOwnProperty(kt)) { kt = 'other' }
                  console.log(u, kc)
                  if (!reports['like'][kt]) {
                    reports['like'][kt] = {
                      daily: {},
                      weekly: {},
                      monthly: {}
                    }
                  }
                  if (this.refine === false || kt.hasOwnProperty(this.groupSelected)) {
                    reports['like'][kt].daily[ymd]++
                    reports['like'][kt].weekly[w]++
                    reports['like'][kt].monthly[ym]++
                    reports['like']['total'].daily[ymd]++
                    reports['like']['total'].weekly[w]++
                    reports['like']['total'].monthly[ym]++
                    reports.totals['like'][kt]++
                    reports.totals['like']['total']++
                    reports.unique.daily[ymd][u] = true
                    reports.unique.weekly[w][u] = true
                    reports.unique.monthly[ym][u] = true
                    reports.unique.total[u] = true
                  }
                }
              } else {
                // console.log('* Comment Check!')
                for (let kt of Object.values(metaSummary[y][m][d][k][u])) {
                  let ktname = '' + kt
                  // console.log(u, kt)
                  ktname = ktname.split('_')[0]
                  if (!reports.totals.comment.hasOwnProperty(kt)) { ktname = 'other' }
                  if (this.refine === false || kt.hasOwnProperty(this.groupSelected)) {
                    reports[k].daily[ymd]++
                    reports[k].weekly[w]++
                    reports[k].monthly[ym]++
                    reports.totals[k]++
                    reports.unique.daily[ymd][u] = true
                    reports.unique.weekly[w][u] = true
                    reports.unique.monthly[ym][u] = true
                    reports.unique.total[u] = true
                    // console.log(reports['comment'][ktname], reports['comment']['total'])
                  }
                }
              }
            }
          } else {
            // console.log('No Data for: ' + k + ' ' + ymd)
          }
        }
      }
      for (let t of Object.keys(reports.unique)) {
        console.log('reportユニーク', reports.unique)
        if (t !== 'total') {
          for (let d of Object.keys(reports.unique[t])) {
            reports.unique[t][d] = Object.keys(reports.unique[t][d]).length
          }
        } else {
          reports.unique[t] = Object.keys(reports.unique[t]).length
        }
      }
      for (let t of Object.keys(reports.poster)) {
        if (t !== 'total') {
          for (let d of Object.keys(reports.poster[t])) {
            reports.poster[t][d] = Object.keys(reports.poster[t][d]).length
          }
        } else {
          reports.poster[t] = Object.keys(reports.poster[t]).length
        }
      }
      for (let t of Object.keys(reports.liker)) {
        if (t !== 'total') {
          for (let d of Object.keys(reports.liker[t])) {
            reports.liker[t][d] = Object.keys(reports.liker[t][d]).length
          }
        } else {
          reports.liker[t] = Object.keys(reports.liker[t]).length
        }
      }
      console.log(dateLabels.weekly, dateLabels.monthly)
      dateLabels.weekly = [...new Set(dateLabels.weekly)]
      dateLabels.monthly = [...new Set(dateLabels.monthly)]
      console.log(dateLabels.weekly, dateLabels.monthly)
      // console.log('this?', this.chartData, this.viewRange)
      console.log('Actives', Object.values(reports.unique[this.viewRange]))
      console.log('Actives:Total', Object.values(reports.unique[this.viewRange]).reduce((a, b) => { return a + b }))
      reports.totals.actives = Object.values(reports.unique[this.viewRange]).reduce((a, b) => { return a + b })
      reports.chartData = {
        summary: {
          datasets: [{
            label: this.$t('activesStr'),
            data: Object.values(reports.unique[this.viewRange]),
            borderColor: '#ff6600',
            backgroundColor: 'transparent',
            fill: false,
            type: 'line'
          }, {
            label: this.$t('okrDetailType'),
            data: Object.values(reports['objectives'][this.viewRange]),
            backgroundColor: '#333399',
            type: 'bar'
          }, {
            label: this.$t('keyResultDetailType'),
            data: Object.values(reports['keyresults'][this.viewRange]),
            backgroundColor: '#6666ff',
            type: 'bar'
          }, {
            label: this.$t('oneOnTitleType'),
            data: Object.values(reports['1on1s'][this.viewRange]),
            backgroundColor: '#00cc99',
            type: 'bar'
          }, {
            label: this.$t('rtfbType'),
            data: Object.values(reports['rtfbs'][this.viewRange]),
            backgroundColor: '#cc6600',
            type: 'bar'
          }],
          labels: dateLabels[this.viewRange]
        },
        comments: {
          datasets: [{
            label: this.$t('commentLabelTitle'),
            data: Object.values(reports['comment']['total'][this.viewRange]),
            borderColor: '#cccc00',
            backgroundColor: 'transparent',
            fill: false,
            type: 'line'
          }, {
            label: this.$t('okrDetailType'),
            data: Object.values(reports['comment']['objectives'][this.viewRange]),
            backgroundColor: '#333399',
            type: 'bar'
          }, {
            label: this.$t('keyResultDetailType'),
            data: Object.values(reports['comment']['keyresults'][this.viewRange]),
            backgroundColor: '#6666ff',
            type: 'bar'
          }, {
            label: this.$t('oneOnTitleType'),
            data: Object.values(reports['comment']['1on1s'][this.viewRange]),
            backgroundColor: '#00cc99',
            type: 'bar'
          }, {
            label: this.$t('rtfbType'),
            data: Object.values(reports['comment']['rtfbs'][this.viewRange]),
            backgroundColor: '#cc6600',
            type: 'bar'
          }],
          labels: dateLabels[this.viewRange]
        },
        likes: {
          datasets: [{
            label: this.$t('niceBtnTitle'),
            data: Object.values(reports['like']['total'][this.viewRange]),
            borderColor: '#ffcc00',
            backgroundColor: 'transparent',
            fill: false,
            type: 'line'
          }, {
            label: this.$t('rtfbType'),
            data: Object.values(reports['like']['rtfbs'][this.viewRange]),
            backgroundColor: '#cc6600',
            type: 'bar'
          }, {
            label: this.$t('commantLabelTitle'),
            data: Object.values(reports['like']['comments'][this.viewRange]),
            backgroundColor: '#cccc00',
            type: 'bar'
          }],
          labels: dateLabels[this.viewRange]
        }
      }
      if (liteMode) {
        // liteMode処理
        reports.chartData.summary.datasets.splice(1, 2)
        reports.chartData.comments.datasets.splice(1, 2)
      }
      console.log('this.chartData', reports.chartData)
      console.log('reports', reports)
      return reports
    }
  }
}
</script>
<style lang="scss" scoped>
.view-range-button-col {
  text-align: right;
  display: inline;
  position: relative;
  // width: 100%;
}
#manage-wrapper .manage-table .main-column {
  overflow: auto;
}
.active-wrap {
  height: auto;
  .tab-content {
    height: 100%;
    .tab-pane {
      height: 100%;
      .v-chart {
        height: 100%;
        min-height: 50vh;
        .chart {
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          height: 100%;
          min-height: 50vh;
        }
      }
    }
  }
}
.modal-body {
  height: 70%;
}
.btn-height-size {
  max-height: 26px;
}
.input-group-addon {
  max-height: 30px;
}
.buttons b-btn{
  padding-left: 10px;
}
.buttons {
  padding-top: 2px;
}
.check-mark {
  content: " ";
  z-index: 10;
  display: table-caption;
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  background-image: url("../../../static/img/assets/success.png");
  background-position: center;
  background-size: 100%;
  position: relative;
  left: 0;
  top: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/report/ReportActivity.vue